var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.757,
    height: 132.83,
    viewBox: "0 0 155.757 132.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-2.608 -4.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M150.168,107.473H51.792a8.2,8.2,0,0,0-8.2,8.2v8.2a8.2,8.2,0,0,0,8.2,8.19h98.376a8.2,8.2,0,0,0,8.2-8.19v-8.2a8.2,8.2,0,0,0-8.2-8.2M28.454,115.436l-18.9-11.812c-3.835-2.4-6.944-.675-6.944,3.849v24.592c0,4.531,3.109,6.254,6.944,3.849l18.9-11.8c3.835-2.39,3.835-6.291,0-8.681M150.168,58.289H51.792a8.2,8.2,0,0,0-8.2,8.2v8.2a8.2,8.2,0,0,0,8.2,8.2h98.376a8.206,8.206,0,0,0,8.2-8.2v-8.2a8.2,8.2,0,0,0-8.2-8.2M9.552,86.745l18.9-11.812c3.835-2.4,3.659-5.983-.389-8.014L9.94,57.864c-4.055-2.031-7.332,0-7.332,4.524V82.881c0,4.539,3.109,6.254,6.944,3.864M150.168,9.105H51.792a8.2,8.2,0,0,0-8.2,8.2v8.2a8.2,8.2,0,0,0,8.2,8.2h98.376a8.206,8.206,0,0,0,8.2-8.2V17.3a8.2,8.2,0,0,0-8.2-8.2M28.454,17.06l-18.9-11.8c-3.835-2.4-6.944-.675-6.944,3.849V33.7c0,4.524,3.109,6.247,6.944,3.857l18.9-11.812c3.835-2.39,3.835-6.291,0-8.681",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.bd0ef16021930a55fc7e0f0a8e7b7ba9.svg";
export { ForwardRef as ReactComponent };